module.exports = __webpack_public_path__ + "static/media/avatar_default.5197f0f8.webp";